/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 16.08.2016.
 */

import {PendingState, SuccessState, ErrorState} from '../../utils';

import {
  INIT_LH_SDK
} from '../../actions/common/actions-common';

import {
  FETCH_ALL_RECORDS, ADD_TO_SCHEDULE, REMOVE_FROM_SCHEDULE
} from '../../actions/npvr/action-npvr';

import {
  EMIT_COLLECTION_RECORDS_UPDATE
} from '../../actions/emit/actions-emit';

const INIT_STATE = {
  records: {
    inProgress: false,
    collection: []
  }
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {

    case SuccessState(INIT_LH_SDK):

      return {
        ...state,
        records: {
          ...state.records,
          inProgress: false,
          collection: [...lh.common.records]
        }
      };

    case EMIT_COLLECTION_RECORDS_UPDATE:

      return {
        ...state,
        records: {
          ...state.records,
          collection: [...action.payload]
        }
      };

    case PendingState(ADD_TO_SCHEDULE):

      return {
        ...state,
        records: {
          ...state.records,
          inProgress: true
        }
      };

    case SuccessState(ADD_TO_SCHEDULE):

      return {
        ...state,
        records: {
          ...state.records,
          inProgress: false
        }
      };

    case PendingState(REMOVE_FROM_SCHEDULE):

      return {
        ...state,
        records: {
          ...state.records,
          inProgress: true
        }
      };

    case SuccessState(REMOVE_FROM_SCHEDULE):

      return {
        ...state,
        records: {
          ...state.records,
          inProgress: false
        }
      };

    case PendingState(FETCH_ALL_RECORDS):

      return {
        ...state,
        records: {
          ...state.records,
          inProgress: true,
          collection: []
        }
      };

    case SuccessState(FETCH_ALL_RECORDS):

      return {
        ...state,
        records: {
          ...state.records,
          inProgress: false,
          collection: [...action.payload]
        }
      };

    case ErrorState(FETCH_ALL_RECORDS):

      return {
        ...state,
        records: {
          ...state.records,
          inProgress: false
        }
      };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/npvr/reducer-npvr.js